import React, { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';
import './global-footer.css';

const GlobalFooter = props => {
  const [disclaimerRows, setDisclaimerRows] = useState([]);

  function waitForUserSettings(callback) {
    const interval = setInterval(() => {
      var userSettings = typeof window.GlobalUserSettings != 'undefined' && window.GlobalUserSettings.user_id
        ? window.GlobalUserSettings
        : typeof window.UserSettings != 'undefined' && window.UserSettings.user_id
          ? window.UserSettings
          : undefined;
      if (userSettings !== undefined) {
        clearInterval(interval);
        callback(userSettings);
      }
    }, 500);
  }

  useEffect(() => {
    waitForUserSettings((userSettings) => {
      var disclaimer = userSettings
        && userSettings.config
        && Array.isArray(userSettings.config.disclaimer)
          ? userSettings.config.disclaimer
          : [];
      setDisclaimerRows(disclaimer);
    });
  }, []);
  return (
    <div id='globalFooter'>
      
      <div>
        <span>&#11205;</span>&nbsp;&nbsp; 
        The information contained in <b>OSS</b> is strictly confidential and represents <b>HP Inc&apos;s</b> 
        &nbsp;commercial secret. By logging into the system <b>I confirm</b> that:
        &nbsp;&nbsp;<span>&#11205;</span>
        <ol>
          <li>I will not use the data for private purposes and</li>
          <li>I understand the confidential nature of this information and 
              undertake to not disclose it to any third parties and</li>
          <li>I understand the disclosure of this information to any 
              third party parties represents a violation of <b>HP Inc&apos;s</b> 
              &nbsp;confidentiality policy and may lead to disciplinary actions. </li>
          {disclaimerRows.map((row, index) => {
            const safeDisclaimerRow = DOMPurify.sanitize(String(row || ''));
            return (
              <li
                key={`disclaimer-${index}`}
                dangerouslySetInnerHTML={{ __html: safeDisclaimerRow }}
              />
            );
          })}
        </ol>
      </div>
    </div>
  )
}

export default GlobalFooter;
